export default{
    tableRow:{
        height: 80
    },
};